<template>
  <div id="plashka" class="plashka">
    <div class="plashka__desktop">
      <img
        v-if="$i18n.locale === 'ua'"
        src="~@/assets/img/global/plashka.jpg"
        alt=""
      />
      <img
        v-if="$i18n.locale === 'ru'"
        src="~@/assets/img/global/plashka-ru.jpg"
        alt=""
      />
    </div>
    <div class="plashka__mobile">
      <img
        v-if="$i18n.locale === 'ua'"
        src="~@/assets/img/global/plashka-mobile.jpg"
        alt=""
      />
      <img
        v-if="$i18n.locale === 'ru'"
        src="~@/assets/img/global/plashka-mobile-ru.jpg"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "Plashka"
};
</script>

<style lang="scss" scoped>
.plashka {
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  user-select: none;
  z-index: 10;
  img {
    display: block;
    width: 100%;
  }
  &__desktop {
    display: block;
  }
  &__mobile {
    display: none;
  }
  @media screen and (max-width: 767px) {
    &__desktop {
      display: none;
    }
    &__mobile {
      display: block;
    }
  }
}
</style>
